import { useLocation } from 'react-router-dom';

import * as MiscStyles from '../../style/misc';
import FlexStyles from '../../style/flex';

import { scale } from '../../util/scale';

import CardContainer from '../UI/CardContainer';
import CardContent from '../UI/CardContent';
import Button from '../buttons/Button';

const largeUpdateHeader = scale({
  fontSize: '30px',
  fontWeight: 600,
  marginBottom: 8,
  lineHeight: 1.3,
});

const updateHeader = scale({
  fontSize: '28px',
  fontWeight: 600,
  marginBottom: 8,
  lineHeight: 1.3,
});

const updateText = scale({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 400,
  marginBottom: '12px',
});

const bigMonth = scale({
  fontSize: ['15px', '18px'],
  marginBottom: [4, 0],
  fontWeight: 500,
  textTransform: 'uppercase',
});

const backgroundImage = (imageUrl) =>
  scale({
    backgroundImage: `url(${imageUrl})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    position: 'relative',
    width: '100%',
    height: ['200px', '240px'],
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
  });

const UpdatePreview = ({ update, isMostRecent = false }) => {
  const location = useLocation();
  const isOnProfilePage = location.pathname.includes('profile');
  const isOnTeamImpactPage = location.pathname.includes('teams');
  const date = new Date(update.published_at);
  const month = date.toLocaleString('en-us', { month: 'short' });
  const year = date.toLocaleString('en-us', { year: 'numeric' });
  return (
    <div key={update.header}>
      <div css={{ marginBottom: 24 }}>
        <CardContainer
          css={
            isOnProfilePage || isOnTeamImpactPage
              ? null
              : {
                  backgroundColor: 'var(--background-gray)',
                  border: '1px solid var(--border-color)',
                  boxShadow: 'none',
                }
          }
        >
          {isMostRecent && <div css={backgroundImage(update.feature_image)} />}
          <CardContent>
            <div css={[FlexStyles.noWrapFlex, FlexStyles.alignItemsStart]}>
              <div css={MiscStyles.marginRightScale([0, 24, 40])}>
                <p css={[bigMonth, MiscStyles.showOnMobile]}>
                  {month}
                  {year}
                </p>
                <h3 css={isMostRecent ? largeUpdateHeader : updateHeader}>
                  {update.title}
                </h3>
                <p css={updateText}>{update.custom_excerpt}...</p>
                <div css={MiscStyles.maxWidth(160)}>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`/blog/${update.slug}`}
                  >
                    <Button size="medium" text="Read update →" />
                  </a>
                </div>
              </div>
              <div css={MiscStyles.hideOnMobile}>
                <p css={bigMonth}>{month}</p>
                <p css={MiscStyles.opacity(0.8)}>{year}</p>
              </div>
            </div>
          </CardContent>
        </CardContainer>
      </div>
    </div>
  );
};

export default UpdatePreview;
